// extracted by mini-css-extract-plugin
export default {"msgIcon":"style_msgIcon__ANIB3","CustomEmpty":"style_CustomEmpty__3aUwG","EmptyIcon":"style_EmptyIcon__R+8FR","EmptyText":"style_EmptyText__NHrTW"};